import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";

import PsContext from "../../context";
import { MOB_ICONS, queryParam, upperCase, useQuery } from "../../utils";
import Header from "../header";

const PaymentStatus = (props) => {
  const context = useContext(PsContext);
  const [showGif, setShowGif] = useState(true);
  const navigate = useNavigate();
  const params = useParams();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const q = useQuery();

  const paramValue = (paramName) => {
    let d = queryParam(q);

    return d[paramName] || "";
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGif(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Header title="Payment Status" backAction={[]} rightActions={[]} />
      <div className="page-content-wrapper">
        <br />
        <div className="container">
          <Card>
            <Card.Body>
              <Row>
                <Col md={6} sm={6} xs={6}>
                  <label>Order Id</label>
                </Col>
                <Col md={6} sm={6} xs={6} className="text-end">
                  <label>{upperCase(paramValue("order_no"))}</label>
                </Col>
              </Row>
              <Row className="py-2 border-top mt-2">
                {params.staus == "1" ? (
                  <Col md={12} sm={12} xs={12} className="text-center">
                    <img
                      src={
                        showGif
                          ? MOB_ICONS.PAYMENT_SUCCESS_GIF
                          : MOB_ICONS.PAYMENT_SUCCESS_IMG
                      }
                      className="m-0 p-0"
                      style={{ width: "200px", height: "200px" }}
                    />
                  </Col>
                ) : (
                  <>
                    <Col md={6} sm={6} xs={6}>
                      <label>Status</label>
                    </Col>
                    <Col md={6} sm={6} xs={6} className="text-end">
                      <label>
                        <span className="badge badge-danger">Error</span>
                      </label>
                    </Col>
                  </>
                )}
              </Row>
            </Card.Body>
          </Card>
          <Card className="mt-4">
            <Card.Header>Instructions</Card.Header>
            <Card.Body>
              1. The payment has been debited from your account but is not
              reflecting on this page, Don't try to make another payment at this
              time.
              <hr />
              2. The status will be updated within 12 hours or automatically
              refunded to your account.
              <hr />
              3. For further assistance, please contact the institution.
              {params.staus != "1" && (
                <>
                  <hr />
                  4. Since the status is not showing as “Success,” please check
                  the payment status on the “Track Order Status” page.
                  <Row className="mt-4">
                    <Col md={12} className="text-center">
                      <Link
                        to="/stu/app/track-order-status"
                        className="btn btn-primary"
                      >
                        <i class="fa-solid fa-shuffle me-2"></i> Track Payment
                        Status
                      </Link>
                    </Col>
                  </Row>
                </>
              )}
            </Card.Body>
          </Card>
          <Row className="mt-4">
            <Col md={12} className="text-center">
              <Link to="/stu/app" className="btn btn-primary">
                <i class="fa-solid fa-house me-2"></i> Go to dashboard
              </Link>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export default PaymentStatus;
